define(["require", "exports", "tslib", "@arcgis/core/Graphic", "@arcgis/core/layers/GraphicsLayer", "@arcgis/core/symbols/SimpleLineSymbol", "../components/Map", "../model/services/EventManager", "../model/services/SrmsServiceManager", "../utils/ColourUtil", "../utils/GeometryFactory", "./Events", "./UserStore"], function (require, exports, tslib_1, Graphic_1, GraphicsLayer_1, SimpleLineSymbol_1, Map_1, EventManager_1, SrmsServiceManager_1, ColourUtil_1, GeometryFactory_1, Events_1, UserStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MapStore = exports.applyVectorLayerStyles = exports.prepareVectorLayerStyles = exports.getVectorLayerStyle = exports.setVectorLayerStyle = exports.VectorLayerLayoutStyle = exports.VectorLayerPaintStyle = void 0;
    Graphic_1 = tslib_1.__importDefault(Graphic_1);
    GraphicsLayer_1 = tslib_1.__importDefault(GraphicsLayer_1);
    SimpleLineSymbol_1 = tslib_1.__importDefault(SimpleLineSymbol_1);
    exports.VectorLayerPaintStyle = {};
    exports.VectorLayerLayoutStyle = {};
    function setVectorLayerStyle(cache, mapId, layerId, prop, value) {
        mapId = mapId.toLowerCase();
        layerId = layerId.toLowerCase();
        if (!cache[mapId]) {
            cache[mapId] = {};
        }
        if (!cache[mapId][layerId]) {
            cache[mapId][layerId] = {};
        }
        cache[mapId][layerId][prop] = value;
    }
    exports.setVectorLayerStyle = setVectorLayerStyle;
    function getVectorLayerStyle(cache, mapId, layerId, prop) {
        mapId = mapId.toLowerCase();
        layerId = layerId.toLowerCase();
        return cache[mapId] && cache[mapId][layerId] && cache[mapId][layerId][prop];
    }
    exports.getVectorLayerStyle = getVectorLayerStyle;
    function prepareVectorLayerStyles(mapId, layer) {
        mapId = mapId.toLowerCase();
        let style = layer.currentStyleInfo.style;
        let toDarkColour = (k, v) => {
            let nextColour;
            if (v && typeof v == "string") {
                let colour = v.toUpperCase();
                let white = "#FFFFFF";
                let eee = "#EEE";
                let darkGrey = "#333333";
                if (colour == "#4E4E4E") {
                    nextColour = white;
                }
                if (colour == "#E1E1E1") {
                    nextColour = darkGrey;
                }
                if (colour == "#828282") {
                    nextColour = white;
                }
                if (colour == "#F2F2F2") {
                    nextColour = darkGrey;
                }
                if (colour == "#99BAC2") {
                    nextColour = white;
                }
                if (colour == "#686868") {
                    nextColour = white;
                }
                if (colour == "#9C9C9C") {
                    nextColour = white;
                }
                if (k == "text-halo-color" && colour == white) {
                    nextColour = darkGrey;
                }
                if (k == "text-halo-color" && colour == "#F2F2F2") {
                    nextColour = darkGrey;
                }
            }
            return { nextColour };
        };
        for (let l of style.layers) {
            let layerId = l.id.toLowerCase();
            if (/Potential other interests over land \(strata layer\)|Police Station|Points of interest|\- Search\)/gi.test(layerId)) {
                console.log("Hiding", l.id, l["source-layer"]);
                layer.setStyleLayerVisibility(l.id, "none");
            }
            for (let prop in l.paint) {
                setVectorLayerStyle(exports.VectorLayerPaintStyle, mapId, layerId, prop, l.paint[prop]);
                let { nextColour } = toDarkColour(prop, l.paint[prop]);
                if (nextColour) {
                    setVectorLayerStyle(exports.VectorLayerPaintStyle, mapId.replace("light", "dark"), layerId, prop, nextColour);
                }
            }
            for (let prop in l.layout) {
                const minFontSize = 12.5;
                const minLetterSpacing = 0.1;
                if (prop == "text-size" && l.layout[prop] < minFontSize) {
                    l.layout[prop] = minFontSize;
                    layer.setLayoutProperties(l.id, l.layout);
                }
                else if (prop == "text-letter-spacing" && l.layout[prop] < minLetterSpacing) {
                    l.layout[prop] = minLetterSpacing;
                    layer.setLayoutProperties(l.id, l.layout);
                }
                setVectorLayerStyle(exports.VectorLayerLayoutStyle, mapId, layerId, prop, l.layout[prop]);
                let { nextColour } = toDarkColour(prop, l.layout[prop]);
                if (nextColour) {
                    setVectorLayerStyle(exports.VectorLayerLayoutStyle, mapId.replace("light", "dark"), layerId, prop, nextColour);
                }
            }
        }
    }
    exports.prepareVectorLayerStyles = prepareVectorLayerStyles;
    function applyVectorLayerStyles(mapId, layer) {
        mapId = mapId.toLowerCase();
        let style = layer.currentStyleInfo.style;
        console.log("Apply theme", mapId);
        for (let l of style.layers) {
            let invalidateLayout = false;
            let invalidatePaint = false;
            let layerId = l.id.toLowerCase();
            for (let prop in l.paint) {
                let v = getVectorLayerStyle(exports.VectorLayerPaintStyle, mapId, layerId, prop);
                if (v && v !== l.paint[prop]) {
                    l.paint[prop] = v;
                    invalidatePaint = true;
                }
            }
            for (let prop in l.layout) {
                let v = getVectorLayerStyle(exports.VectorLayerLayoutStyle, mapId, layerId, prop);
                if (v && v !== l.layout[prop]) {
                    l.layout[prop] = v;
                    invalidateLayout = true;
                }
            }
            if (invalidateLayout) {
                console.log("set layout", layerId, l.layout);
                layer.setLayoutProperties(l.id, l.layout);
            }
            if (invalidatePaint) {
                console.log("set paint", layerId, l.paint);
                layer.setPaintProperties(l.id, l.paint);
            }
        }
    }
    exports.applyVectorLayerStyles = applyVectorLayerStyles;
    class MapStore {
        get Map() {
            return this.map;
        }
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "map", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "config", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "defaultPolylineSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleLineSymbol_1.default({
                    style: "solid",
                    color: ColourUtil_1.ColourUtil.PrimaryActive,
                    width: 1.5
                })
            });
            this.storeManager = storeManager;
            EventManager_1.EventManager.Instance.on(Events_1.CONFIG_READY_EVENT, (config) => {
                this.config = config;
                if (this.map) {
                    this.renderLgaMemberships();
                }
            });
            EventManager_1.EventManager.Instance.on(Events_1.MAP_READY_EVENT, (map) => {
                this.map = map;
                if (this.config) {
                    this.renderLgaMemberships();
                }
            });
            EventManager_1.EventManager.Instance.on(Events_1.MAP_REFRESH_EVENT, () => {
                (0, Map_1.refreshMap)(this.map);
            });
        }
        renderLgaMemberships(removeAfter = 5000) {
            if (!(0, UserStore_1.isUserStateGovAdminOfficer)() &&
                !this.storeManager.entityStore.HasEntity) {
                SrmsServiceManager_1.SrmsServiceManager.Instance.Common.getAuthorisedLgasWithGeometry(true, true).then((results) => {
                    const lgaGraphics = new GraphicsLayer_1.default({ id: "lgaGraphics" });
                    let lgaGraphic;
                    if (results.length > 0) {
                        for (const lgaDetail of results) {
                            lgaGraphic = new Graphic_1.default({
                                geometry: GeometryFactory_1.GeometryFactory.toPolyline(lgaDetail.ShapePolyline.paths),
                                symbol: this.defaultPolylineSymbol
                            });
                            lgaGraphics.add(lgaGraphic);
                        }
                        this.map.map.layers.add(lgaGraphics);
                        (0, Map_1.goTo)(this.map, lgaGraphics.graphics.toArray());
                        setTimeout(() => {
                            lgaGraphics.removeAll();
                            this.map.map.remove(lgaGraphics);
                        }, removeAfter);
                    }
                });
            }
        }
    }
    exports.MapStore = MapStore;
});
